import { APPS } from '@squirrellearningltd/go-shared-utils';

export const APP_NAME = APPS.go_read_teacher;